import {merge} from 'lodash';
import AssessmentResult from '../../../values/AssessmentResult';
import Assessment from '../assessment';
import {URL_LENGTH_ID, URLS_POINTS} from '@axyseo/const/analysis';

/**
 * Represents the assessment that checks whether there are three or more consecutive sentences beginning with the same word.
 */
export default class UrlLengthAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {object} config The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: URL_LENGTH_ID,
      priority: 'high',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-audit/on-page-seo/checklist#url-length',
      fixPosition: 'url handle',
      ctaType: 'fix',
      title: 'URL length',
      content: {
        good: 'URL length is optimized, less than 75 characters.',
        improve: '',
        bad: 'Keep it less than 75 characters for better readability and SEO.'
      }
    };

    this.identifier = URL_LENGTH_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string}}
   */
  calculateResult(paper) {
    let status = 'bad';
    const length = paper.getDomain().length + paper.getSlug().length;
    if (length < 75) {
      status = 'good';
    }

    return {
      score: this.getScore(URLS_POINTS, status) || 0,
      status
    };
  }

  /**
   *
   * @param paper
   * @param researcher
   * @param i18n
   * @returns {AssessmentResult}
   */
  getResult({paper, researcher}) {
    const calculatedResult = this.calculateResult(paper);
    const assessmentResult = new AssessmentResult({config: this._config});

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   * Checks if the sentence beginnings assessment is applicable to the paper.
   *
   * @param {Object}      paper       The paper to check.
   * @param {Researcher}  researcher  The researcher object.
   *
   * @returns {boolean} Returns true if the language is available and the paper is not empty.
   */
  isApplicable(paper, researcher) {
    return true;
  }
}
